/** Tempo di lettura con icona cronometro custom (accento ciano). Riuso card + articolo. */
export function ReadingTime({
  minutes,
  label,
  className,
}: {
  minutes: number;
  label: string;
  className?: string;
}) {
  return (
    <span className={`inline-flex items-center gap-1.5 ${className ?? ""}`}>
      <svg
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
        className="shrink-0"
      >
        {/* cassa cronometro */}
        <circle cx="12" cy="13.5" r="7.5" stroke="currentColor" strokeWidth="1.5" opacity="0.55" />
        {/* corona + pulsante in alto */}
        <path d="M9.5 3.2h5M12 3.2v2.1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.55" />
        {/* lancetta ciano che segna il tempo */}
        <path d="M12 13.5V9.6" stroke="hsl(var(--primary))" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M12 13.5l2.6 1.6" stroke="hsl(var(--primary))" strokeWidth="1.8" strokeLinecap="round" />
        <circle cx="12" cy="13.5" r="1.05" fill="hsl(var(--primary))" />
      </svg>
      <span>
        {minutes} {label}
      </span>
    </span>
  );
}
